 const header = document.querySelector(".header-wrapper");

// Apply on window load


// standalone meu 
document.addEventListener('DOMContentLoaded', function () {
  /* ------------------------------
   * 1) Convert some mega menus into normal dropdowns
   * ------------------------------ */

  const standaloneMenus = [
        'Details-HeaderMenu-4',
       
        
  ];

  standaloneMenus.forEach(menuId => {
    const details = document.getElementById(menuId);
    if (!details) return;

    // Remove mega-menu styling, use normal submenu styling
    details.classList.remove('mega-menu');
    details.classList.add('header__submenu');

    const megaContent = details.querySelector('.mega-menu__content');
    if (!megaContent) return;

    const megaList = megaContent.querySelector('.mega-menu__list');
    if (!megaList) return;

    // Create Dawn-style dropdown UL
    const dropdownList = document.createElement('ul');
    dropdownList.className = 'header__submenu list-menu list-menu--disclosure motion-reduce';
    dropdownList.setAttribute('role', 'list');

    // Move all <li> from mega list into dropdown list
    Array.from(megaList.children).forEach(li => dropdownList.appendChild(li));

    // Replace mega content with normal dropdown
    megaContent.replaceWith(dropdownList);
  });

  /* ------------------------------
   * 2) Shared behavior for ALL header menus
   *    - Only one open at a time
   *    - Hover to open (desktop)
   *    - Click or hover anywhere outside header closes all
   * ------------------------------ */

  const allDetails = Array.from(
    document.querySelectorAll('details[id^="Details-HeaderMenu-"]')
  );

  // Only one open at a time (works for click + JS open)
  allDetails.forEach(details => {
    details.addEventListener('toggle', () => {
      if (details.open) {
        allDetails.forEach(other => {
          if (other !== details) other.open = false;
        });
      }
    });
  });

  const canHover = window.matchMedia('(hover: hover)').matches;

  if (canHover) {
    // Hover on summary = open menu
    allDetails.forEach(details => {
      const summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('mouseenter', () => {
        if (!details.open) {
          details.open = true; // triggers toggle → closes others
        }
      });
    });
  }

  // Root header element (adjust selector if needed)
  const headerRoot =
    document.querySelector('.header-wrapper') ||
    document.querySelector('header');

  function isOutsideMenusAndHeader(target) {
    // Inside any header menu <details>?
    if (target.closest('details[id^="Details-HeaderMenu-"]')) return false;

    // Inside header wrapper itself?
    if (headerRoot && headerRoot.contains(target)) return false;

    // Everything else is "outside"
    return true;
  }

  // Click outside header / menus → close all
  document.addEventListener('click', (e) => {
    if (isOutsideMenusAndHeader(e.target)) {
      allDetails.forEach(d => { d.open = false; });
    }
  });

  // Hover outside header / menus → close all (desktop only)
  if (canHover) {
    document.addEventListener('mouseover', (e) => {
      if (isOutsideMenusAndHeader(e.target)) {
        allDetails.forEach(d => { d.open = false; });
      }
    });
  }
});
